export enum SnackbarNotificationType {
    Info = 'info',
    Warning = 'warning',
    Success = 'success',
    Error = 'error'
}

export interface SnackbarToastItem {
    id: string;
    type: SnackbarNotificationType;
    message: string;
    durationMs: number;
}
